import { render, staticRenderFns } from "./SetupXpress.vue?vue&type=template&id=83cd26c6&"
import script from "./SetupXpress.vue?vue&type=script&lang=js&"
export * from "./SetupXpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports